import { updateLayoutState } from '../state/state.layout'
import { motionTransition } from '../utilities/transitions'

export const transitionNavLayout = async (expandedNav: boolean) =>
    await motionTransition(() => {
        updateLayoutState({
            expandedNav: !expandedNav,
        })
    })

// this should probably also move to floating room state??
export const setChatMinimized = (minimized: boolean) => {
    updateLayoutState({ minimized })
}
export const setColorSchemeLocked = (lockedColorScheme: boolean) => {
    updateLayoutState({ lockedColorScheme })
}
